import { SegmentDefinition, SegmentEditReference } from '@cwd/Views/Segments/interfaces';
import { loadSegmentPreview } from '@cwd/views/Segments/services/requests';
import { SegmentPreviewResult } from '@cwd/views/Segments/interfaces';
import { bsAlert, AlertTypes } from '@shared/components/bsAlerts';

export const getSegmentForPreview = (segmentDefinition: SegmentDefinition) => {
    const now = new Date().toISOString();
    const emptyGuid = '00000000-0000-0000-0000-000000000000';

    const segmentForPreview = {
        SegmentId: emptyGuid,
        SegmentDefinition: segmentDefinition,
        Name: '',
        AccessControlList: [],
        Description: '',
        CreatedAt: now,
        CreatedBy: { UserId: emptyGuid, FirstName: '', LastName: '', Name: '', UserName: '' },
        Modified: now,
        ModifiedBy: { UserId: emptyGuid, FirstName: '', LastName: '', Name: '', UserName: '' },
        SerializedExpression: '',
        OwnedByEvent: null,
        OwnedByIssue: null,
        OwnedBySurvey: null,
        OwnedByObjectId: null,
        OwnedByJourney: null,
        OwnedByRelation: null,
        Tags: [],
    } as SegmentEditReference;

    return segmentForPreview;
};

export const previewNodeSegment = async (segmentDefinition: SegmentDefinition, signal?: AbortSignal) => {
    try {
        const result = (await loadSegmentPreview(getSegmentForPreview(segmentDefinition), '', 0, signal)) as SegmentPreviewResult;
        return result;
    } catch (error: any) {
        if (error.name === 'AbortError') {
            throw error;
        }
        bsAlert({
            title: 'Error previewing segment',
            content: error.message,
            type: AlertTypes.Danger,
        });

        return null;
    }
};
